<template>
  <div>
    <div class="divs">
      <div>全部项目 新启动 进行中 维护中 已结束</div>
      <div>
        <span class="demonstration">时间：</span>
        <el-date-picker
          size="mini"
          v-model="value1"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <li>XXXXX项目</li>
        <li>XXXXX业务管理</li>
        <li>XXXXX项目</li>
        <li>XXXXX项目</li>
      </div>
    </div>
    <div>
      <h4>XXXXX项目</h4>
      <span>选择项目版本：</span>
      <el-select size="mini"></el-select>
      <div>
        <el-container>
          <!-- <el-header style="text-align: right; font-size: 12px">
            <el-dropdown>
              <i class="el-icon-setting" style="margin-right: 15px"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>查看</el-dropdown-item>
                <el-dropdown-item>新增</el-dropdown-item>
                <el-dropdown-item>删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span>小小</span>
          </el-header> -->
          <el-main>
            <div style="width:100%">
              <!-- <div class="floatleft" style="height:100%" >
                <img
                  style="height:100px;width:100px"
                  src="http://a.hiphotos.baidu.com/image/pic/item/f2deb48f8c5494ee5080c8142ff5e0fe99257e19.jpg"
                />
              </div>-->
              <div class="floatleft" style="width:100%">
                <span class="text-size20px textalignleft">XXXXXX管理系统</span>
                <!-- <br />
                <span class="textalignleft">点击添加项目描述</span>-->
                <div class="floatleft">
                  <ul class="ul">
                    <li>管理员：</li>
                    <li>创建人：</li>
                    <li>项目类型：</li>
                    <li>项目阶段：</li>
                    <li>资源池：</li>
                  </ul>
                </div>
                <div class="floatleft">
                  <ul class="ul">
                    <li>张三</li>
                    <li>李四</li>
                    <li>产品开发</li>
                    <li>开发阶段</li>
                    <li>900人天</li>
                  </ul>
                </div>
                <div class="floatleft">
                  <ul class="ul">
                    <li>项目成员：</li>
                    <li>创建时间：</li>
                    <li>所属行业：</li>
                    <li>风险池：</li>
                  </ul>
                </div>
                <div class="floatleft">
                  <ul class="ul">
                    <li>9</li>
                    <li>2020-2-22</li>
                    <li>其他</li>
                    <li>80人天</li>
                  </ul>
                </div>
              </div>
              <!-- <div>
              <a href="#">删除项目</a>
              </div>-->
              <p></p>
              <!-- <div>
                项目简介：
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis
              </div>-->
            </div>
          </el-main>
        </el-container>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      value1: ''
    }
  }
}

</script>
<style scoped>
.divs {
  float: left;
}
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}
.el-aside {
  color: #333;
}
.floatleft {
  float: left;
}
.text-size20px {
  font-size: 24px;
  font-weight: bold;
}
.textalignleft {
  text-align: left;
}
.ul {
  float: left;
  list-style: none;
  text-align: left;
  margin-left: 10%;
  width: 80%;
}
li {
  line-height: 50px;
}
#header {
  float: left;
  line-height: 1px;
  /* font-family: Arial, Helvetica, sans-serif; */
  font-size: 18px;
  /* color: #ffcc33; */
  margin-left: 10%;
  /* width: 80%; */
  height: 30px;
}
#header #headerul {
  /* margin-top: 1px; */
  /* margin-bottom: 1px; */
  margin-left: 0px;
  list-style: none;
}
#header #headerul li {
  /* border: 1px solid #ffffff; */
  /* padding: 5px 15px 5px 10px; */
  display: block;

  float: left;
}
#header #headerul #forum {
  text-align: center;
  width: 150px;
}
#header #headerul #amount {
  text-align: center;
  width: 100px;
}
#tr #trul #amount {
  text-align: center;
  width: 100px;
}
#tr {
  float: left;
  line-height: 1px;
  /* font-family: Arial, Helvetica, sans-serif; */
  font-size: 18px;
  color: #3399ff;
  margin-left: 10%;
  width: 50%;
  height: 30px;
  background: #cccccc;
}
#tr #trul {
  /* margin-top: 1px; */
  /* margin-bottom: 1px; */
  margin-left: 0px;
  list-style: none;
}
#tr #trul li {
  /* border: 1px solid #ffffff; */
  /* padding: 5px 15px 5px 10px; */
  display: block;

  float: left;
}
#tr #trul #forum {
  text-align: center;
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/views/statistical-statement/StatisticalStatement.vue